import styled, { keyframes } from 'styled-components'

const flash = keyframes`
  0% { opacity: 0; }
  15% { opacity: 1; }
  100% { opacity: 0; }
`

export const CartItemWrapper = styled.div`
  position: relative;
  isolation: isolate;
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr) auto auto 48px;
  align-items: center;
  column-gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--color-line);
  flex-shrink: 0;
  scroll-margin: 16px 0;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 1600px) {
    grid-template-columns: 48px minmax(0, 1fr) auto auto 48px;
    column-gap: 8px;
    padding: 10px 0;
  }
`

export const CartItemFlash = styled.span`
  position: absolute;
  inset: 2px -12px;
  z-index: -1;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.primary}1F;
  pointer-events: none;
  opacity: 0;
  animation: ${flash} 0.9s ease-out;
`

const thumb = `
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #f5f7f9;
  overflow: hidden;
`

export const CartItemImage = styled.div`
  ${thumb}
  padding: 4px;

  @media (max-width: 1600px) {
    width: 48px;
    height: 48px;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const CartItemIcon = styled.div`
  ${thumb}
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  line-height: 1;

  @media (max-width: 1600px) {
    width: 48px;
    height: 48px;
    font-size: 1.75rem;
  }
`

export const CartItemInfo = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;

  .title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 0.95rem;
    font-weight: 600;
    line-height: 1.3;
    color: var(--color-text);
    overflow-wrap: anywhere;
    hyphens: manual;
    overflow-wrap: anywhere;

    @media (max-width: 1600px) {
      font-size: 0.9rem;
      line-height: 1.25;
    }
  }

  .unit-price {
    font-size: 0.8rem;
    color: var(--color-muted);
    font-variant-numeric: tabular-nums;
  }
`

export const CartItemQty = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  border: 1px solid var(--color-line);
  border-radius: 12px;
  background: var(--color-body);
  overflow: hidden;

  .qty {
    min-width: 36px;
    padding: 0 2px;
    text-align: center;
    font-size: 1.1rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: var(--color-text);
  }
`

export const QtyButton = styled.button`
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.global};
  transition: background 0.1s;
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 20px;
    height: 20px;
  }

  &:active {
    background: #e6e9ee;
  }
`

export const CartItemPrice = styled.div`
  min-width: 72px;
  text-align: right;
  white-space: nowrap;
  font-weight: 700;
  font-size: 1.05rem;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.global};
`

export const CartItemRemove = styled.button`
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-muted);
  transition: background 0.1s, color 0.1s;
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 20px;
    height: 20px;
  }

  &:active {
    background: var(--color-line);
    color: ${({ theme }) => theme.colors.red};
  }
`
